import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';

import Checkbox from '../../Checkbox/Checkbox';
import Sort from '../Sort/Sort';
import TextContaining from '../TextContaining/TextContaining';

const TextContainingFilteBox = (props) => {
  const {
    column,
    filterOption,
    classes = {},
    sortingType,
    sortingSelected,
    onUpdateSorting,
    onUpdateFilters,
    disableFilters,
    hideFilterSection,
    selectAllLabel,
    // bottomContent,
  } = props;

  const filter = {
    id: filterOption.id,
  };
  const isAllOptionVisible = true;

  const isCheckedAll = filterOption && !filterOption.isActive;

  const handleSelectAll = () => {
    onUpdateFilters({
      ...filterOption,
      isActive: false,
    });
  };

  const handleSelectFilter = () => {
    onUpdateFilters({
      ...filterOption,
      isActive: true,
    });
  };

  const handleUpdateFilters = (filterOptions) => {
    onUpdateFilters({
      value: filterOptions[0].value,
    });
  };

  return (
    <div className={clsx(`filterBoxContainer`, classes.options)}>
      {column.sorting && (
        <Sort
          column={column}
          sortingType={sortingType}
          sortingSelected={sortingSelected}
          onUpdateSorting={onUpdateSorting}
        />
      )}
      {!hideFilterSection && (
        <div className={clsx(`filterByContainer`, classes.filterBy)}>
          <h4>Filter By</h4>
          <div className="filterItems">
            {isAllOptionVisible && (
              <div className={clsx(`filterItem`, disableFilters && 'disabled')}>
                <div className="filterCheckbox">
                  <Checkbox value="all" onChange={handleSelectAll} checked={isCheckedAll} />
                  <span>{selectAllLabel ? selectAllLabel : 'All'}</span>
                </div>
              </div>
            )}

            <div key={`textContainingFilterKey`} className="filterItem">
              <TextContaining
                filter={filter}
                filterSelected={[filterOption]}
                onUpdate={handleUpdateFilters}
                onSelect={handleSelectFilter}
                isChecked={!filterOption.isActive}
              />
            </div>
          </div>
        </div>
      )}
      {/* <div className="bottomContent">{bottomContent}</div> */}
    </div>
  );
};

export { TextContainingFilteBox };
